import { render, staticRenderFns } from "./Coverages.vue?vue&type=template&id=093ae5ae&scoped=true"
import script from "./Coverages.vue?vue&type=script&lang=js"
export * from "./Coverages.vue?vue&type=script&lang=js"
import style0 from "./Coverages.vue?vue&type=style&index=0&id=093ae5ae&prod&lang=scss&scoped=true"
import style1 from "./Coverages.vue?vue&type=style&index=1&id=093ae5ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093ae5ae",
  null
  
)

export default component.exports